export default __webpack_public_path__ + "static/media/tomoscan-logo-light.e68df508.svg";